// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"113":"f8b3eff8","221":"4c17fdd4"}[chunkId] + ".chunk.css";
};